import * as  TYPE from "./actionTypes"

export const common = (commons, tournaments, vendors) => {
    return {
        type: TYPE.COMMON,
        commons: commons,
        tournaments: tournaments,
        vendors: vendors
    }
}
